<template>
  <div class="parctical-unit">
    <div class="card mb-16">
      <div class="card-img">
        <img class="card-img" src="@/assets/image/index/图标／首页／公司@2x.png" />
      </div>
      <div class="card-content">
        <div class="card-title">建设单位</div>
        <div class="card-text">{{ detailData.constructionUnit }}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="card mt-16  mb-16">
      <div class="card-img">
        <img class="card-img" src="@/assets/image/index/图标／首页／公司@2x.png" />
      </div>
      <div class="card-content">
        <div class="card-title">勘察单位</div>
        <div class="card-text">{{ detailData.surveyUnit }}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="card mt-16  mb-16">
      <div class="card-img">
        <img class="card-img" src="@/assets/image/index/图标／首页／公司@2x.png" />
      </div>
      <div class="card-content">
        <div class="card-title">设计单位</div>
        <div class="card-text">{{ detailData.designUnit }}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="card mt-16  mb-16">
      <div class="card-img">
        <img class="card-img" src="@/assets/image/index/图标／首页／公司@2x.png" />
      </div>
      <div class="card-content">
        <div class="card-title">施工单位</div>
        <div class="card-text">{{ detailData.implementingUnit }}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="card mt-16 mb-16">
      <div class="card-img">
        <img class="card-img" src="@/assets/image/index/图标／首页／公司@2x.png" />
      </div>
      <div class="card-content">
        <div class="card-title">监理单位</div>
        <div class="card-text">{{ detailData.supervisionUnit }}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="card mt-16 mb-16">
      <div class="card-img">
        <img class="card-img" src="@/assets/image/index/图标／首页／公司@2x.png" />
      </div>
      <div class="card-content">
        <div class="card-title">审计单位</div>
        <div class="card-text">{{ detailData.auditUnit }}</div>
      </div>
    </div>
    <el-divider></el-divider>
  </div>
</template>
<script>
import { getProject } from '@/utils/indexApi';
export default {
  data() {
    return {
      detailData: {}
    }
  },
  methods: {
    getList() {
      getProject().then(res => {
        this.detailData = res.data
        console.log(res.data);

      })
    }
  },
  created() {
    this.getList()
  }
}
</script>
<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}

.mb-16 {
  margin-bottom: 16px;
}

.el-divider {
  background: #BBC6D6;
  opacity: 0.3;
}

.card {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #27507D;
  box-shadow: inset 0px 1px 6px 0px rgba(81, 216, 255, 0.5);
  border-radius: 8px;
  backdrop-filter: blur(5px);
  overflow: hidden;
  .card-img {
    width: 66px;
    height: 66px;
  }
  .card-content {
    .card-title {
      overflow: hidden;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 17px;
      color: #FFA83B;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
    .card-text {
      width: 270px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-wrap: nowrap;
      margin-top: 18px;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }
}
</style>
